import { html, unsafeCSS } from 'lit';
import { property, state } from 'lit/decorators.js';
import DERModuleElement from '~/modules/utils/der-module-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './der-content-quote-carousel.styles';

import '~/ui/components/module-title';
import '~/ui/components/tag';
import '~/ui/components/controls';
import '~/ui/components/button';
import '~/ui/objects/quote-carousel';
import '~/modules/der-content-quote-carousel/quote-card';

import { QuotesData } from './types';
import { Task } from '@lit/task';
import { ifDefined } from 'lit/directives/if-defined.js';

export class QuoteCarousel extends DERModuleElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: String }) identifier = '86373';
    @property({ type: Boolean }) useLocalData = false;
    @property({ type: Number }) quoteCount = 3; // for Testing with MSW

    @state()
    quotesData: QuotesData | undefined;

    private _contentTask = new Task(this, {
        task: async ([identifier, lang, tenant, quoteCount]: [string, string, string, number]) => {
            const url = new URL(`https://dtch-contenthub.azurewebsites.net/api/expert-tips`);
            url.searchParams.set('id', identifier);
            url.searchParams.set('lang', lang);
            url.searchParams.set('tenant', tenant);
            url.searchParams.set('quoteCount', String(quoteCount));

            const response = await fetch(url.toString());

            if (!response.ok) {
                throw new Error(`Failed to fetch quotes: ${response.statusText}`);
            }

            const responseData = await response.json();

            if (
                !responseData ||
                !responseData.quotes ||
                !Array.isArray(responseData.quotes) ||
                responseData.quotes.length === 0
            ) {
                throw new Error('Invalid quotes data received');
            }
            this.quotesData = responseData;
        },
        args: () => [this.identifier, this.lang, this.tenant, this.quoteCount] as [string, string, string, number],
    });

    override render() {
        return this._contentTask.render({
            pending: () => html``,
            complete: () => html`
                <div class="m-quote-carousel">
                    <div class="m-quote-carousel__title-wrapper">
                        <der-ui-module-title
                            suptitle="${this.quotesData?.supTitle || ''}"
                            title="${this.quotesData?.title || ''}"
                            intro="${this.quotesData?.intro || ''}"
                        ></der-ui-module-title>
                    </div>

                    <div class="m-quote-carousel__body-wrapper">
                        <der-ui-quote-carousel
                            .slides=${this.quotesData?.quotes ?? []}
                            .slidesPerView=${{
                                mobile: 1.25,
                            }}
                            .renderSlide=${((quote: QuotesData['quotes'][number], index: number) => html`
                                <quote-card
                                    .index=${index}
                                    .quote=${quote}
                                    lang=${this.lang}
                                    length=${ifDefined(this.quotesData?.quotes.length)}
                                ></quote-card>
                            `) as (slide: unknown, index: number, length: number) => unknown}
                        ></der-ui-quote-carousel>
                    </div>
                </div>
            `,
            error: () => html``,
        });
    }
}
